import { Controller } from "stimulus"

export default class extends Controller {
  static values = {
    btnBaseClasses: String
  }

  static targets = ['btn']

  connect() {
    this.addClasses()
  }

  addClasses() {
    this.btnTarget.className += ` ${this.btnBaseClassesValue}`
  }

  followModulePayload(action) {
    const form = this.element.querySelector('form')
    // 路由是 /p/:username/follow 或 /p/:username/unfollow（見 config/routes.rb），
    // 最後一段是動作本身，設計師名稱是倒數第二段，不能直接 .pop()。
    const segments = form ? form.action.split('/') : []
    const creatorName = segments.length >= 2 ? segments[segments.length - 2] : ''
    return {
      page_type: 'designer',
      module: 'follow_button',
      landing_path: window.location.pathname,
      target_type: 'follow_button',
      target_id: creatorName,
      position: 0,
      action,
    }
  }

  afterSuccess(e) {
    let [data, status, xhr] = e.detail
    let resp = xhr.response

    // 回應內容是「操作後」該顯示的按鈕：成功關注後改顯示 unfollow 按鈕，反之亦然，
    // 見 app/helpers/profile_button_helper.rb 的 link_to_follow/link_to_unfollow。
    const isNowFollowing = resp.includes('unfollow-btn')
    if (window.trackingEvent) {
      window.trackingEvent.track_module_click(this.followModulePayload(isNowFollowing ? 'follow' : 'unfollow'))
    }

    this.element.innerText = ''
    this.element.insertAdjacentHTML('afterbegin', resp)
    this.addClasses()
  }
}
